// extracted by mini-css-extract-plugin
export default {"form":"SignUp_form__rgCUY","rightColumn":"SignUp_rightColumn__OvoVp"};